import _ from "lodash";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import useScore from "../../../../hooks/useScore";
import { IStudentScore } from "../../../../models/students.model";

interface IProps {
  rawData: IStudentScore[]|undefined;
}

const Homework: FC<IProps> = ({
  rawData,
}) => {
  const { handleData } = useScore();
  const [tableHeaders, setTableHeaders] = useState<any>([]);
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (rawData) {
      const _data: any = _.cloneDeep(rawData);
      let _tableHeaders: any = [];
      _data.forEach((item: any) => {
        item.homeworkScoreInfo?.forEach((subitem: any) => {
          subitem.label = `${subitem.depth1Name}/${subitem.depth2Name}/${subitem.subjectName}`;
          _tableHeaders.push(subitem);
        });
      });
      setData(_data);
      _tableHeaders = _.uniqBy(_tableHeaders, 'label');
      _tableHeaders = handleData(_tableHeaders);
      setTableHeaders(_tableHeaders);
    }
  }, [rawData]);

  const getScore = (scores: any, label: string) => {
    const score = scores.find((item: any) => item.label === label);
    if (score?.conversionScore === 0 || score?.conversionScore) {
      return `${score.evaluationInput} (${score.conversionScore})`;
    } else if (score?.conversionScore === null) {
      return 'X';
    }

    return 'N/A';
  }

  return tableHeaders.length
    ? (
      <div className='comm-table__area rowType stats mt-0'>
        <table
          style={{ /* maxWidth: `${((tableHeaders?.length || 0) + 1) * 200}px` */ }}
        >
          <colgroup>
            {[...Array((tableHeaders?.length || 0) + 1)].map((item, index) => (
              <col key={index} width="200px" />
            ))}
          </colgroup>
          <tbody>
            <tr>
              <th rowSpan={3} />
              {tableHeaders?.map((item: any, index: number) => {
                if (item.colSpan !== 0)
                  return <th key={index} colSpan={item.colSpan}>{item.depth1Name}</th>;
                else
                  return null;
              })}
            </tr>
            <tr>
              {tableHeaders?.map((item: any) => (
                <th>{item.subjectName}</th>
              ))}
            </tr>
            <tr>
              {tableHeaders?.map((item: any) => (
                <th>{item.depth2Name}</th>
              ))}
            </tr>
            {data.map((item: any, index: number) => (
              <tr key={index}>
                <td>{moment(item.timetableDate).format('M/D')}</td>
                {tableHeaders?.map((subitem: any, subindex: number) => (
                  <td
                    key={subindex}
                    style={{ backgroundColor: getScore(item.homeworkScoreInfo, subitem.label) === 'N/A' ? 'gainsboro' : ''}}
                  >
                    {getScore(item.homeworkScoreInfo, subitem.label) === 'N/A' ? '' : getScore(item.homeworkScoreInfo, subitem.label)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )
    : null;
}

export default Homework;
